import { classNames } from '@dimjs/utils';
import { NativeProps, withNativeProps } from '../../utils/native-props';
import { px2rem } from '../../utils/pxrem';
import './style.less';

export type ArrowIconVarStyle = '--arrow-color';

export type ArrowDirection = 'top' | 'right' | 'bottom' | 'left';
export type ArrowIconProps = {
  direction?: ArrowDirection;
  // 填充模式
  fill?: 'solid' | 'outline' | 'none';
  disabled?: boolean;
  size?: number;
} & NativeProps<ArrowIconVarStyle>;

const getMoveSize = (moveSize: number, direction: ArrowDirection) => {
  if (direction === 'bottom' || direction === 'right') {
    return `-${moveSize}rem`;
  }
  return `${moveSize}rem`;
};

const getDefaultSize = (fill: ArrowIconProps['fill']) => {
  return fill === 'outline' ? 30 : 20;
};

export const ArrowIcon = (props: ArrowIconProps) => {
  const fill = props.fill || 'none';
  const size = props.size || getDefaultSize(fill);
  const direction = props.direction || 'right';

  const className = classNames('v-arrow', `v-arrow-${fill}`, `v-arrow-${direction}`, {
    'v-arrow-disabled': props.disabled,
  });
  const dpiSize = px2rem(size);
  const moveSize = px2rem(Math.sqrt(2 * size * size) / 4);
  return withNativeProps(
    {
      className: props.className,
      style: {
        ...props.style,
        '--arrow-size': dpiSize,
        '--arrow-move-size': getMoveSize(parseFloat(moveSize), direction),
      },
    },
    <div className={className}>
      <div className="v-arrow-rotate" style={{ height: dpiSize, width: dpiSize }}>
        <div className="v-arrow-icon"></div>
      </div>
    </div>,
  );
};
